
import { PusherConnection } from '../utils/pusher_connection';
import { context } from "../constants/context";
import { LiveStatus } from './live_status';

//////////////////////////////
// a class for tracking update for a single company you are currently "logged in as"

class CurrentCompanyTracker {

    async trackCompany(company){
        try {
            // no need to resubscribe if we already are
            if (this.company && this.company.id == company.id) return;

            if (this.company){
                await this.unsubscribeFromLiveUpdates();
            }
            this.company = company;

            await this.subscribeToLiveUpdates();
        } catch (err) {
            console.error(err);
        }
    }

    async subscribeToLiveUpdates(){
        if (!this.pusherConnection) {
            this.pusherSubscribe();
        }
    }

    async unsubscribeFromLiveUpdates() {
        if (this.pusherConnection) {
            await this.pusherUnsubscribe();
        }

        if (this.liveStatus) {
            this.liveStatus.unsubscribe();
            delete this.liveStatus;
        }
    }

    async initLiveStatus() {
        if (this.company.$has('live_status') && !this.liveStatus) {
            this.liveStatus = new LiveStatus(this.company);
            await this.liveStatus.updateStatus();
        }
    }


    pusherSubscribe() {
        this.pusherConnection = new PusherConnection(this.company);

        const channelName = this.company.$link('self').href.replace(/https?:\/\//, 'private-')
            .replace(/\//g, '-')
            .replace('-' + context.apiVersion + '-', '-v1-')
            .replace(/:/g, '_');
        this.pusherChannelName = channelName;
        this.pusherChannelPromise = new Promise((resolve, reject) => {
            this.pusherConnection.subscribe(channelName).then((channel) => {
                this.pusher_channel = channel;
                resolve(channel);

            });

        }, this);
        if (this.company.$has('client_company')) {
            const clientChannelName = this.company.$link('client_company').href.replace(/https?:\/\//, 'private-')
                .replace(/\//g, '-')
                .replace('-' + context.apiVersion + '-', '-v1-')
                .replace(/:/g, '_');
            if (clientChannelName !== channelName) {
                this.pusherClientChannelName = channelName;
                this.clientPusherChannelPromise = new Promise((resolve, reject) => {
                    this.pusherConnection.subscribe(clientChannelName).then((channel) => {
                        this.client_pusher_channel = channel;
                        resolve(channel);
                    });
                });
            } else {
                this.clientPusherChannelPromise = this.pusherChannelPromise;
            }
        }
    }

    async pusherUnsubscribe() {
        if (this.pusherConnection){
            await this.pusherConnection.unsubscribe(this.pusherChannelName);
            if (this.pusherClientChannelName)
                await this.pusherConnection.unsubscribe(this.pusherClientChannelName);
        }
        delete this.pusherConnection;
    }

}

const currentCompanyTracker = new CurrentCompanyTracker();

export {
    currentCompanyTracker
}
